module.exports = __webpack_public_path__ + "img/oval.a79f7c1e.svg";